export default __webpack_public_path__ + "static/media/CHA.50b7ba77.svg";